import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconAdsComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Ads${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 12 12" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M10.5 1.75a.5.5 0 00-.692-.462L2 4.53v-.444a.25.25 0 00-.25-.25h-.5a.25.25 0 00-.25.25V7.916c0 .137.112.25.25.25h.5a.25.25 0 00.25-.25v-.31l1.458.55a2.416 2.416 0 00-.006.17c0 1.347 1.111 2.424 2.461 2.424.788 0 1.492-.365 1.943-.935l1.967.742a.5.5 0 00.63-.254l.047.018V1.75zm-4.587 8a1.45 1.45 0 01-1.445-1.214l2.368.894c-.25.2-.571.32-.923.32z"/></svg>;
}

const IconAds = React.forwardRef(IconAdsComponent);
export default IconAds;
